import {
  Menu,
  Button,
  MenuButton,
  MenuList,
  MenuItem,
  Textarea,
  Progress,
  MenuOptionGroup,
  MenuItemOption,
} from "@chakra-ui/react";
import { ChevronDownIcon, ArrowForwardIcon, ArrowDownIcon } from "@chakra-ui/icons";
import styles from "./Main.module.css";
import CompositeTextArea from  "../components/CompositeTextArea";
import { useEffect, useState, useRef } from 'react';
import axios from "axios";


const Main = () => {

  // const base

  const initConversation = {
    0: {
      "message": "Hi",
      "username": "User 1"
    },
    1: {
      "message": "Hello there!",
      "username": "User 2"
    },
    2: {
      "message": "How r u!",
      "username": "User 1"
    },
    3: {
      "message": "I am doing good! How about you?",
      "username": "User 2"
    }
  }

  const toneList = [
    "Casual",
    "Friendly",
    "Formal"
  ]

  const contextList = [
    "Email",
    "Chat"
  ]

  const contextRef = useRef(null);
  const toneRef = useRef(null);
  const usernameRef = useRef(null);
  // const emailResponseRef = useRef(null);
  const [response, setResponse] = useState("");
  const [userSet, setUserSet] = useState(new Set(["User 1", "User 2"]))
  const [conversation, setConversation] = useState(initConversation);
  const [isLoading, setIsLoading] = useState(false);
  const [conversationConfig, setConversationConfig] = useState({
    "context": "email",
    "num_messages": 5
  })
  const [responseConfig, setResponseConfig] = useState({
    "context": "Email",
    "tone": "Formal",
    "user": "User 1"
  })

  // st.values().next().value

  const addUser = (username) => {
    setUserSet((prevState) => new Set([...prevState, username]));
  };

  const updateMessageUser =  (messageId, username) => {
    setConversation((prevState) => ({
        ...prevState,
        [messageId]: {
          ...prevState[messageId],
          username: username
        }
      })
    );
  };

  const loadConverstation = () => {
    var data = JSON.stringify(conversationConfig);

    // console.log(`${process.env.REACT_APP_API_URL}/generate_conversation`);

    var config = {
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/generate_conversation`,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      data : data
    };

    axios(config)
    .then(function (response) {
      // setConversation(response.data)
      var tempConversation = {}

      response.data.map(messageData=> {
        tempConversation[messageData.id] = {
          username: messageData.name,
          message: messageData.text
        }
      });

      setConversation(tempConversation);
    })
    .catch(function (error) {
      console.log(error);
    });

  }

  const extendConverstation = () => {
    setConversationConfig(prevState => (
      {
        ...prevState,
        num_messages: prevState.num_messages+1
      }
    ));
  }

  const loadUserList = () => {
    const newSet = new Set(Object.entries(conversation).map( ( [ messageId, { message, username }]) => username));
    setUserSet(prevState=>new Set([...prevState, ...newSet]));
    // console.log(userSet);
  }


  const generateResponse = () => {
    // {
    //   "conversation": [
    //     {
    //       "id": "d8976d79-6191-9042-5b68-106e49799049",
    //       "text": "proident ut Lorem",
    //       "name": "in",
    //       "signature": "irure culpa amet fugiat"
    //     },
    //     {
    //       "id": "ba344e2e-eab3-e9d7-ee50-6248c77eb660",
    //       "text": "commodo",
    //       "name": "est eiusmod laboris",
    //       "signature": "veniam"
    //     }
    //   ],
    //   "context": "email",
    //   "tone": "formal",
    //   "user": "User 1"
    // }

    setIsLoading(true);

    const parsedConverstation = Object.entries(conversation).map(([ messageId, { message, username }])=>({
      id: messageId,
      text: message,
      name: username,
      signature: "",
    }));



    var data = JSON.stringify({
      conversation: parsedConverstation,
      context: responseConfig.context.toLowerCase(),
      tone: responseConfig.tone.toLowerCase(),
      user: responseConfig.user.toLowerCase(),
    });

    // console.log(data);

    var config = {
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/generate_response`,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      data : data
    };

    axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      setResponse(response.data);
      setIsLoading(false);
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  // useEffect(()=>{
  //   setResponseConfig(st.values().next().value);
  // })

  useEffect(()=>{
    loadUserList();
    // console.log(conversation);
  }, [conversation])


  useEffect(()=> {
    loadConverstation();
  }, [conversationConfig]);

  return (
    <div className={styles.main}>
      <div className={styles.mailResponseGenerator}>
        MAIL RESPONSE GENERATOR
      </div>
      <form className={styles.frameParent}>
        <div className={styles.frameGroup}>
        {
          Object.entries(conversation).map( ( [ messageId, { message, username }]) => {
            // console.log(`Rendering CompositTextArea list ${messageId}`);
            return (
              <CompositeTextArea
                key={messageId}
                messageId={messageId}
                username={username}
                message={message}
                userSet={userSet}
                addUser={addUser}
                updateMessageUser={updateMessageUser}
                setConversation={setConversation}
              />);
          } )
        }
         {/* <Button
            size="lg"
            variant="solid"
            colorScheme="blue"
            rightIcon={<ArrowDownIcon />}
            onClick={extendConverstation}
          >
            Extend conversation
          </Button>*/}
        </div>
        <div className={styles.dropdowndefaultParent1}>
          <Menu closeOnSelect={false}>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              variant="outline"
              colorScheme="blue"
              size="sm"
            >
              Context
            </MenuButton>
            <MenuList>
              <MenuOptionGroup
                // ref={contextRef}
                onChange={(context)=>{setResponseConfig(prevState=> ({...prevState, context: context}));}}
                defaultValue="Email"
                title={null}
                type='radio'>
                {
                contextList.map(context => {
                  return <MenuItemOption key={context} value={context}>{context}</MenuItemOption>;
                })
                }
              </MenuOptionGroup>
            </MenuList>
          </Menu>
          <Menu closeOnSelect={false}>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              variant="outline"
              colorScheme="blue"
              size="sm"
            >
              Tone
            </MenuButton>
            <MenuList>
              <MenuOptionGroup
                // ref={toneRef}
                onChange={(tone)=>{setResponseConfig(prevState=> ({...prevState, tone: tone}));}}
                defaultValue="Formal"
                title={null}
                type="radio"
                >
                {
                  toneList.map(tone => {
                    return <MenuItemOption key={tone} value={tone}>{tone}</MenuItemOption>;
                  })
                }
              </MenuOptionGroup>
            </MenuList>
          </Menu>
          <Menu closeOnSelect={false}>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              variant="outline"
              colorScheme="blue"
              size="sm"
            >
              Respondee
            </MenuButton>
            <MenuList>
              <MenuOptionGroup
                // ref={usernameRef}
                onChange={(username)=>{setResponseConfig(prevState=> ({...prevState, user: username}));}}
                defaultValue="User 1"
                title={null}
                type="radio"
                >
                {
                  [...userSet].map(username=>(
                    <MenuItemOption key={username} value={username}>{username}</MenuItemOption>
                  ))
                }
              </MenuOptionGroup>
            </MenuList>
          </Menu>
          <Button
            isLoading={isLoading}
            loadingText="Loading Response"
            variant="solid"
            colorScheme="blue"
            rightIcon={<ArrowForwardIcon />}
            onClick={generateResponse}
            size="sm"
            // opacity={1.0}
          >
            Generate Response
          </Button>
        </div>
        <Textarea
          className={styles.textAreaflushed4}
          variant="flushed"
          placeholder="Text Area"
          backgroundColor="gray.100"
          rows={5}
          value={response}
          // ref={emailResponseRef}
          // isDisabled
          isReadOnly
        />
      </form>
{/*      <Button
        variant="solid"
        colorScheme="teal"
        rightIcon={<ArrowForwardIcon />}
      >
        TRY API
      </Button>*/}
    </div>
  );
};

export default Main;
